import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import HowItWorks from './HowItWorks';
import iconHelp from './assets/icon_help.png';
import iconSupport from './assets/icon_support.png';
import iconOperations from './assets/icon_operations.png';
import iconPayments from './assets/icon_payments.png';
import iconSettings from './assets/icon_settings.png';
import api from './api';

function UserMenu({ currentTheme, onToggleTheme }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isWithdrawOpen, setIsWithdrawOpen] = useState(false); 
    const [isSettingsOpen, setIsSettingsOpen] = useState(false); 
    const [isHistoryOpen, setIsHistoryOpen] = useState(false); 
    const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);
    const [isBlacklistOpen, setIsBlacklistOpen] = useState(false);
    
    // Поля формы вывода
    const [method, setMethod] = useState('crypto'); // 'crypto' | 'card'
    const [amount, setAmount] = useState('');
    const [network, setNetwork] = useState('TRC20');
    const [wallet, setWallet] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [comment, setComment] = useState('');

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' }); 

    const [transactions, setTransactions] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);

    // Чёрный список
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [blacklistLoading, setBlacklistLoading] = useState(false);
    const [userToBlockInput, setUserToBlockInput] = useState(''); // <--- ДОБАВИТЬ
    const [blockMessage, setBlockMessage] = useState({ text: '', type: '' }); // <--- ДОБАВИТЬ
    
    const menuRef = useRef(null);

    const [emailService, setEmailService] = useState(true);
const [emailPromo, setEmailPromo] = useState(true);
const [isSavingSettings, setIsSavingSettings] = useState(false);

// Загружаем текущие настройки с бэкенда при открытии/монтировании
useEffect(() => {
  api.get('accounts/me/')
    .then(res => {
      if (res.data?.profile) {
        setEmailService(res.data.profile.email_service_notifications ?? true);
        setEmailPromo(res.data.profile.email_promo_notifications ?? true);
      }
    })
    .catch(err => console.error('Ошибка загрузки настроек профиля:', err));
}, []);

// Функция сохранения изменений на бэкенд
const handleToggleNotification = async (type, currentValue) => {
  const newValue = !currentValue;
  
  // Оптимистично обновляем UI
  if (type === 'service') setEmailService(newValue);
  if (type === 'promo') setEmailPromo(newValue);

  setIsSavingSettings(true);
  try {
    await api.patch('accounts/me/', {
      profile: {
        email_service_notifications: type === 'service' ? newValue : emailService,
        email_promo_notifications: type === 'promo' ? newValue : emailPromo,
      }
    });
  } catch (err) {
    console.error('Ошибка сохранения настроек:', err);
    // Откатываем UI назад при ошибке
    if (type === 'service') setEmailService(currentValue);
    if (type === 'promo') setEmailPromo(currentValue);
  } finally {
    setIsSavingSettings(false);
  }
};

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchTransactionHistory = async () => {
        setHistoryLoading(true);
        const token = localStorage.getItem('token');
        try {
            const response = await fetch('/api/payments/history/', {
                headers: {
                    ...(token && { 'Authorization': `Bearer ${token}` })
                }
            });
            if (response.ok) {
                const data = await response.json();
                setTransactions(data);
            }
        } catch (error) {
            console.error('Ошибка загрузки истории операций:', error);
        } finally {
            setHistoryLoading(false);
        }
    };

    const fetchBlacklist = async () => {
      setBlacklistLoading(true);
      const token = localStorage.getItem('token') || localStorage.getItem('access_token') || localStorage.getItem('access');
      try {
          const response = await fetch('/api/blacklist/', {
              headers: {
                  'Content-Type': 'application/json',
                  ...(token && { 'Authorization': `Bearer ${token}` })
              }
          });
          
          if (response.ok) {
              const data = await response.json();
              
              // Получаем массив
              const rawList = Array.isArray(data) 
                  ? data 
                  : (data.blocked_users || data.users || data.results || []);
          
              // Приводим элементы к единому формату
              const normalizedList = rawList.map((item) => {
                  const targetUser = item.blocked_user || item.blocked || item;
                  return {
                      id: item.id || targetUser.id,
                      username: targetUser.username || item.blocked_username || item.username || `Пользователь #${item.id}`,
                      email: targetUser.email || item.email || 'Заблокирован'
                  };
              });
          
              setBlockedUsers(normalizedList);
          } else {
              setBlockedUsers([]);
          }
      } catch (error) {
          console.error('Ошибка загрузки черного списка:', error);
          setBlockedUsers([]);
      } finally {
          setBlacklistLoading(false);
      }
  };

    const handleUnblockUser = async (userId) => {
      if (!window.confirm('Разблокировать пользователя?')) return;

      const token = localStorage.getItem('token') 
                 || localStorage.getItem('access_token') 
                 || localStorage.getItem('access');

      try {
          // Указываем ТОЧНЫЙ URL из твоего urls.py
          const response = await fetch('/api/blacklist/remove/', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  ...(token && { 'Authorization': `Bearer ${token}` })
              },
              body: JSON.stringify({ user_id: userId })
          });

          if (response.ok) {
              setBlockedUsers((prev) => prev.filter((user) => (user.id || user.blocked_id) !== userId));
          }
      } catch (error) {
          console.error('Ошибка при разблокировке пользователя:', error);
      }
  };

  const handleBlockSubmit = async (e) => {
    e.preventDefault();
    if (!userToBlockInput.trim()) return;

    setBlockMessage({ text: '', type: '' });

    try {
      const token = localStorage.getItem('token');

      const response = await fetch('/api/blacklist/add/', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
              username: userToBlockInput.trim(),
              reason: 'Заблокирован из профиля'
          })
      });

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
            const data = await response.json();
            if (response.ok && data.success) {
                setBlockMessage({ text: 'Пользователь добавлен в черный список!', type: 'success' });
                setUserToBlockInput('');
                fetchBlacklist();
            } else {
                setBlockMessage({ text: data.error || 'Ошибка при блокировке', type: 'error' });
            }
        } else {
            setBlockMessage({ text: 'Сервер вернул ошибку авторизации (HTML)', type: 'error' });
        }
    } catch (error) {
        console.error('Ошибка:', error);
        setBlockMessage({ text: 'Ошибка сети', type: 'error' });
    }
};
    
    const handleOpenHistory = () => {
        setIsHistoryOpen(true);
        setIsOpen(false);
        fetchTransactionHistory();
    };

    const handleOpenBlacklist = () => {
        setIsBlacklistOpen(true);
        setIsOpen(false);
        fetchBlacklist();
    };

    const handleWithdrawSubmit = async (e) => {
        e.preventDefault();
        
        if (parseFloat(amount) < 5) {
            setMessage({ text: 'Минимальная сумма вывода — 10.00 USDT', type: 'error' });
            return;
        }

        if (method === 'card') {
            const cleanCard = cardNumber.replace(/\s+/g, '');
            if (!cleanCard || cleanCard.length < 16 || cleanCard.length > 19) {
                setMessage({ text: 'Введите корректный номер карты РФ (16-19 цифр)', type: 'error' });
                return;
            }
        } else if (!wallet.trim()) {
            setMessage({ text: 'Укажите адрес кошелька', type: 'error' });
            return;
        }

        setLoading(true);
        setMessage({ text: '', type: '' });

        const token = localStorage.getItem('token') 
           || localStorage.getItem('access_token') 
           || localStorage.getItem('access');

        try {
            const payload = {
                method: method,
                amount: parseFloat(amount), 
                network: method === 'crypto' ? network : 'CARD',
                wallet_address: method === 'crypto' ? wallet : '',
                card_number: method === 'card' ? cardNumber.replace(/\s+/g, '') : '',
                comment: comment 
            };

            const response = await fetch('/api/payments/withdraw/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { 'Authorization': `Bearer ${token}` })
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage({ text: 'Заявка успешно создана и отправлена на модерацию!', type: 'success' });
                setAmount('');
                setWallet('');
                setCardNumber('');
                setComment('');
                setNetwork('TRC20');
                setTimeout(() => setIsWithdrawOpen(false), 2000);
            } else {
                setMessage({ text: data.error || 'Произошла ошибка при создании заявки.', type: 'error' });
            }
        } catch (error) {
            setMessage({ text: 'Ошибка соединения с сервером.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };
  
    const isDarkMode = currentTheme === 'dark';

    const renderTxDetails = (tx) => {
        switch (tx.tx_type) {
            case 'deposit':
                return {
                    icon: '↓',
                    bg: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
                    title: 'Пополнение',
                    sign: '+'
                };
            case 'withdraw':
                return {
                    icon: '↑',
                    bg: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
                    title: 'Вывод средств',
                    sign: '-'
                };
            default:
                return {
                    icon: '⚡',
                    bg: 'bg-indigo-500/20 text-indigo-400 border-indigo-500/30',
                    title: 'Задание / Оплата',
                    sign: tx.amount >= 0 ? '+' : ''
                };
        }
    };

    const getDynamicTitle = () => {
        if (isWithdrawOpen) return 'Вывод средств — RealWork.pro';
        if (isHistoryOpen) return 'История операций — RealWork.pro';
        if (isBlacklistOpen) return 'Черный список — RealWork.pro';
        if (isSettingsOpen) return 'Настройки профиля — RealWork.pro';
        if (isHowItWorksOpen) return 'Как это работает — RealWork.pro';
        if (isOpen) return 'Меню пользователя — RealWork.pro';
        return null;
    };

    const isAnyModalOpen = isOpen || isWithdrawOpen || isSettingsOpen || isHistoryOpen || isHowItWorksOpen || isBlacklistOpen;

    return (
      <div className="fixed bottom-6 right-6 z-50" ref={menuRef}>
        {isAnyModalOpen && (
          <Helmet>
            <title>{getDynamicTitle()}</title>
          </Helmet>
        )}

        {/* КНОПКА ОТКРЫТИЯ МЕНЮ (АВАТАР) В СТИЛЕ СТЕКЛА */}
        <button 
          onClick={() => setIsOpen(!isOpen)}
          className="w-14 h-14 transition-all duration-300 hover:scale-105 active:scale-95 shadow-[0_8px_20px_rgba(0,0,0,0.4)] rounded-full overflow-hidden border-2 border-white/20 cursor-pointer"
        >
          <img 
            src="https://raw.githubusercontent.com/igorkay/git.lesson/master/unnamed%20(1).jpg" 
            alt="Menu" 
            className="w-full h-full object-cover"
          />
        </button>
  
        {/* ВЫПАДАЮЩЕЕ МЕНЮ В СТИЛЕ СТЕКЛА */}
        {isOpen && (
          <div className="absolute bottom-16 right-0 w-72 bg-slate-900/80 backdrop-blur-2xl border border-white/15 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className="p-2 space-y-1">
              <button 
                onClick={() => { setIsSettingsOpen(true); setIsOpen(false); }}
                className="w-full text-left px-3.5 py-2.5 hover:bg-white/10 rounded-xl text-sm font-medium text-slate-200 transition-colors cursor-pointer flex items-center gap-3.5"
              >
                <img src={iconSettings} alt="Настройки" className="w-8 h-8 object-contain drop-shadow-md shrink-0" />
                <span>Настройки профиля</span>
              </button>

              <button 
                onClick={() => { setIsWithdrawOpen(true); setIsOpen(false); }}
                className="w-full text-left px-3.5 py-2.5 hover:bg-white/10 rounded-xl text-sm font-medium text-slate-200 transition-colors cursor-pointer flex items-center gap-3.5"
              >
                <img src={iconPayments} alt="Платежная система" className="w-8 h-8 object-contain drop-shadow-md shrink-0" />
                <span>Платежная система</span>
              </button>
              
              <button 
                onClick={handleOpenHistory}
                className="w-full text-left px-3.5 py-2.5 hover:bg-white/10 rounded-xl text-sm font-medium text-slate-200 transition-colors cursor-pointer flex items-center gap-3.5"
              >
                <img src={iconOperations} alt="История операций" className="w-8 h-8 object-contain drop-shadow-md shrink-0" />
                <span>История операций</span>
              </button>

              <button 
                onClick={handleOpenBlacklist}
                className="w-full text-left px-3.5 py-2.5 hover:bg-white/10 rounded-xl text-sm font-medium text-slate-200 transition-colors cursor-pointer flex items-center gap-3.5"
              >
                <div className="w-8 h-8 rounded-xl bg-slate-800/80 border border-white/10 flex items-center justify-center text-rose-400 text-sm shadow-md shrink-0">
                  🚫
                </div>
                <span>Черный список</span>
              </button>

              <button 
                onClick={() => { setIsHowItWorksOpen(true); setIsOpen(false); }}
                className="w-full text-left px-3.5 py-2.5 bg-indigo-500/10 hover:bg-indigo-500/20 border border-indigo-500/10 rounded-xl text-sm font-medium text-indigo-300 transition-colors cursor-pointer flex items-center gap-3.5 mt-1"
              >
                <img src={iconHelp} alt="Как это работает" className="w-8 h-8 object-contain drop-shadow-md shrink-0" />
                <span>Как это работает</span>
              </button>

              <div className="border-t border-white/10 my-1.5"></div>
              
              <a 
                href="mailto:realwork.support@gmail.com?subject=Поддержка Realwork.pro"
                onClick={() => setIsOpen(false)}
                className="w-full text-left px-3.5 py-2.5 hover:bg-rose-500/10 rounded-xl text-sm font-medium text-rose-400 transition-colors flex items-center gap-3.5"
              >
                <img src={iconSupport} alt="Поддержка" className="w-8 h-8 object-contain drop-shadow-md shrink-0" />
                <span>Связь с поддержкой</span>
              </a>
            </div>
          </div>
        )}

        {/* МОДАЛЬНОЕ ОКНО "КАК ЭТО РАБОТАЕТ" */}
        {isHowItWorksOpen && (
          <div className="fixed inset-0 bg-[#090d16]/90 backdrop-blur-md z-[10000] overflow-y-auto">
            <HowItWorks onClose={() => setIsHowItWorksOpen(false)} />
          </div>
        )}

        {/* МОДАЛЬНОЕ ОКНО ЧЕРНОГО СПИСКА */}
        {isBlacklistOpen && (
          <div 
            onClick={() => { setIsBlacklistOpen(false); setBlockMessage({ text: '', type: '' }); }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200"
          >
            <div 
              onClick={(e) => e.stopPropagation()} 
              className="bg-slate-900/80 backdrop-blur-2xl rounded-3xl p-6 w-full max-w-md shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/15 mx-4 max-h-[85vh] flex flex-col"
            >
              {/* Заголовок */}
              <div className="flex justify-between items-center mb-4">
                <div>
                  <h3 className="text-lg font-bold text-white">Черный список</h3>
                  <p className="text-xs text-slate-400 mt-0.5">Управление заблокированными пользователями</p>
                </div>
                <button 
                  onClick={() => { setIsBlacklistOpen(false); setBlockMessage({ text: '', type: '' }); }}
                  className="text-slate-400 hover:text-white text-xl cursor-pointer transition-colors"
                >
                  ✕
                </button>
              </div>

              {/* Сообщение об ошибке/успехе */}
              {blockMessage.text && (
                <div className={`p-2.5 rounded-xl text-xs font-medium mb-3 backdrop-blur-sm border ${
                  blockMessage.type === 'success' 
                    ? 'bg-emerald-500/20 border-emerald-500/30 text-emerald-300' 
                    : 'bg-rose-500/20 border-rose-500/30 text-rose-300'
                }`}>
                  {blockMessage.text}
                </div>
              )}

              {/* Форма быстрого добавления по никнейму */}
              <form onSubmit={handleBlockSubmit} className="mb-4">
                <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1.5">
                  Заблокировать пользователя
                </label>
                <div className="flex gap-2">
                  <input 
                    type="text" 
                    value={userToBlockInput}
                    onChange={(e) => setUserToBlockInput(e.target.value)}
                    placeholder="Введите никнейм..." 
                    className="flex-1 px-3.5 py-2.5 bg-slate-900/50 backdrop-blur-sm border border-white/10 rounded-xl text-xs text-slate-200 placeholder-slate-500 focus:outline-none focus:border-indigo-500 transition-colors shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]"
                  />
                  <button 
                    type="submit"
                    className="px-4 py-2.5 bg-rose-500/20 hover:bg-rose-500/30 border border-rose-500/30 text-rose-300 font-semibold rounded-xl text-xs transition cursor-pointer shrink-0 active:scale-95"
                  >
                    В ЧС
                  </button>
                </div>
              </form>

              <div className="border-t border-white/10 my-1"></div>

              {/* Список заблокированных */}
              <div className="flex-1 overflow-y-auto pr-1 space-y-2.5 my-3 custom-scrollbar">
                {blacklistLoading ? (
                  <div className="py-8 text-center text-xs text-slate-400 animate-pulse">
                    ⏳ Загрузка списка...
                  </div>
                ) : blockedUsers.length === 0 ? (
                  <div className="py-8 text-center text-xs text-slate-400">
                    Ваш черный список пуст
                  </div>
                ) : (
                  blockedUsers.map((user) => (
                    <div 
                      key={user.id} 
                      className="p-3 bg-slate-800/40 border border-white/5 rounded-2xl flex items-center justify-between hover:bg-white/5 transition"
                    >
                      <div className="flex items-center gap-3 overflow-hidden">
                        <div className="w-8 h-8 rounded-xl bg-slate-700/50 border border-white/10 flex items-center justify-center text-xs font-bold text-slate-300 shrink-0">
                          {user.username ? user.username[0].toUpperCase() : 'U'}
                        </div>
                        <div className="flex flex-col truncate">
                          <span className="text-xs font-bold text-slate-200 truncate">
                            {user.username || `Пользователь #${user.id}`}
                          </span>
                          <span className="text-[10px] text-slate-400">
                            {user.email || 'Заблокирован'}
                          </span>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() => handleUnblockUser(user.id)}
                        className="px-3 py-1.5 bg-slate-700/50 hover:bg-slate-700 border border-white/10 text-slate-300 rounded-xl text-xs font-medium transition cursor-pointer shrink-0 ml-2"
                      >
                        Разблокировать
                      </button>
                    </div>
                  ))
                )}
              </div>

              <button 
                type="button"
                onClick={() => { setIsBlacklistOpen(false); setBlockMessage({ text: '', type: '' }); }}
                className="w-full mt-2 bg-slate-800/80 hover:bg-slate-700/80 border border-white/10 text-white font-medium py-2.5 rounded-xl text-xs transition-all active:scale-[0.98] cursor-pointer shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]"
              >
                Закрыть
              </button>
            </div>
          </div>
        )}

        {/* МОДАЛЬНОЕ ОКНО ИСТОРИИ ОПЕРАЦИЙ */}
        {isHistoryOpen && (
          <div 
            onClick={() => setIsHistoryOpen(false)}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200"
          >
            <div 
              onClick={(e) => e.stopPropagation()} 
              className="bg-slate-900/80 backdrop-blur-2xl rounded-3xl p-6 w-full max-w-md shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/15 mx-4 max-h-[80vh] flex flex-col"
            >
              <div className="flex justify-between items-center mb-4">
                <div>
                  <h3 className="text-lg font-bold text-white">История операций</h3>
                  <p className="text-xs text-slate-400 mt-0.5">Все транзакции вашего кошелька</p>
                </div>
                <button 
                  onClick={() => setIsHistoryOpen(false)}
                  className="text-slate-400 hover:text-white text-xl cursor-pointer transition-colors"
                >
                  ✕
                </button>
              </div>

              <div className="flex-1 overflow-y-auto pr-1 space-y-2.5 my-2 custom-scrollbar">
                {historyLoading ? (
                  <div className="py-12 text-center text-sm text-slate-400 animate-pulse">
                    ⏳ Загрузка транзакций...
                  </div>
                ) : transactions.length === 0 ? (
                  <div className="py-12 text-center text-xs text-slate-400">
                    У вас пока нет совершённых операций
                  </div>
                ) : (
                  transactions.map((tx, idx) => {
                    const details = renderTxDetails(tx);
                    return (
                      <div 
                        key={tx.id || idx} 
                        className="p-3 bg-slate-800/40 border border-white/5 rounded-2xl flex items-center justify-between hover:bg-white/5 transition"
                      >
                        <div className="flex items-center gap-3">
                          <div className={`w-9 h-9 rounded-xl border flex items-center justify-center text-base font-bold shrink-0 ${details.bg}`}>
                            {details.icon}
                          </div>
                          <div className="flex flex-col">
                            <span className="text-xs font-bold text-slate-200">{details.title}</span>
                            <span className="text-[10px] text-slate-400">
                              {tx.created_at ? new Date(tx.created_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—'}
                            </span>
                          </div>
                        </div>

                        <div className="text-right">
                          <span className={`block text-xs font-black ${tx.tx_type === 'deposit' ? 'text-emerald-400' : tx.tx_type === 'withdraw' ? 'text-rose-400' : 'text-slate-200'}`}>
                            {details.sign}{Number(tx.amount).toFixed(2)} USDT
                          </span>
                          <span className={`text-[9px] font-bold uppercase ${tx.status === 'success' || tx.status === 'completed' ? 'text-emerald-500' : tx.status === 'pending' ? 'text-amber-500' : 'text-rose-500'}`}>
                            {tx.status === 'success' || tx.status === 'completed' ? 'Успешно' : tx.status === 'pending' ? 'В обработке' : 'Ошибка'}
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              <button 
                onClick={() => setIsHistoryOpen(false)}
                className="w-full mt-4 bg-slate-800/80 hover:bg-slate-700/80 border border-white/10 text-white font-medium py-3 rounded-xl transition-all active:scale-[0.98] cursor-pointer shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]"
              >
                Закрыть
              </button>
            </div>
          </div>
        )}

        {/* МОДАЛЬНОЕ ОКНО НАСТРОЕК ПРОФИЛЯ */}
        {isSettingsOpen && (
          <div 
            onClick={() => setIsSettingsOpen(false)}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200"
          >
            <div 
              onClick={(e) => e.stopPropagation()} 
              className="bg-slate-900/80 backdrop-blur-2xl rounded-3xl p-6 w-full max-w-sm shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/15 mx-4"
            >
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-bold text-white">Настройки профиля</h3>
                <button 
                  onClick={() => setIsSettingsOpen(false)}
                  className="text-slate-400 hover:text-white text-xl cursor-pointer transition-colors"
                >
                  ✕
                </button>
              </div>

              <div className="space-y-4">
                {/* Ночной режим */}
                <div className="flex items-center justify-between p-3 bg-slate-800/40 rounded-2xl border border-white/10">
                  <div className="flex flex-col">
                    <span className="text-sm font-semibold text-slate-200">Ночной режим</span>
                    <span className="text-xs text-slate-400">Экономит заряд и бережет глаза</span>
                  </div>
                  
                  <button 
                    onClick={onToggleTheme}
                    className={`w-12 h-6 rounded-full p-1 transition-colors duration-300 focus:outline-none cursor-pointer ${
                      isDarkMode ? 'bg-indigo-500' : 'bg-slate-600'
                    }`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${
                      isDarkMode ? 'translate-x-6' : 'translate-x-0'
                    }`} />
                  </button>
                </div>

                {/* Сервисные e-mail уведомления */}
                <div className="flex items-center justify-between p-3 bg-slate-800/40 rounded-2xl border border-white/10">
                  <div className="flex flex-col pr-2">
                    <span className="text-sm font-semibold text-slate-200">Сервисные e-mail уведомления</span>
                    <span className="text-xs text-slate-400">Оповещения о статусах заказов и откликах</span>
                  </div>
                  
                  <button 
                    disabled={isSavingSettings}
                    onClick={() => handleToggleNotification('service', emailService)}
                    className={`w-12 h-6 shrink-0 rounded-full p-1 transition-colors duration-300 focus:outline-none cursor-pointer ${
                      emailService ? 'bg-indigo-500' : 'bg-slate-600'
                    }`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${
                      emailService ? 'translate-x-6' : 'translate-x-0'
                    }`} />
                  </button>
                </div>

                {/* Промо и дайджесты */}
                <div className="flex items-center justify-between p-3 bg-slate-800/40 rounded-2xl border border-white/10">
                  <div className="flex flex-col pr-2">
                    <span className="text-sm font-semibold text-slate-200">Новости и приток заказов</span>
                    <span className="text-xs text-slate-400">Дайджесты новых заказов (10+, 20+, 50+), акции и новости</span>
                  </div>
                  
                  <button 
                    disabled={isSavingSettings}
                    onClick={() => handleToggleNotification('promo', emailPromo)}
                    className={`w-12 h-6 shrink-0 rounded-full p-1 transition-colors duration-300 focus:outline-none cursor-pointer ${
                      emailPromo ? 'bg-indigo-500' : 'bg-slate-600'
                    }`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${
                      emailPromo ? 'translate-x-6' : 'translate-x-0'
                    }`} />
                  </button>
                </div>
              </div>

              <button 
                onClick={() => setIsSettingsOpen(false)}
                className="w-full mt-6 bg-slate-800/80 hover:bg-slate-700/80 border border-white/10 text-white font-medium py-3 rounded-xl transition-all active:scale-[0.98] cursor-pointer shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)]"
              >
                Готово
              </button>
            </div>
          </div>
        )}

        {/* ОБНОВЛЕННОЕ МОДАЛЬНОЕ ОКНО ВЫВОДА СРЕДСТВ */}
        {isWithdrawOpen && (
          <div 
            onClick={() => { setIsWithdrawOpen(false); setMessage({ text: '', type: '' }); }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200"
          >
            <div 
              onClick={(e) => e.stopPropagation()} 
              className="bg-slate-900/80 backdrop-blur-2xl rounded-3xl p-6 w-full max-w-md shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/15 mx-4"
            >
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-white">Вывод средств</h3>
                <button 
                  onClick={() => { setIsWithdrawOpen(false); setMessage({ text: '', type: '' }); }}
                  className="text-slate-400 hover:text-white text-xl cursor-pointer transition-colors"
                >
                  ✕
                </button>
              </div>

              {message.text && (
                <div className={`p-3 rounded-xl text-sm font-medium mb-4 backdrop-blur-sm border ${
                  message.type === 'success' 
                    ? 'bg-emerald-500/20 border-emerald-500/30 text-emerald-300' 
                    : 'bg-rose-500/20 border-rose-500/30 text-rose-300'
                }`}>
                  {message.text}
                </div>
              )}

              <form onSubmit={handleWithdrawSubmit} className="space-y-4">
                {/* 1. Выбор способa вывода (Табы - Liquid Glass) */}
                <div>
                  <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1.5">
                    Способ вывода
                  </label>
                  <div className="relative flex p-1 bg-slate-900/50 backdrop-blur-md rounded-2xl border border-white/10 shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]">
                    <div 
                      className={`absolute top-1 bottom-1 left-1 w-[calc(50%-4px)] bg-slate-700/80 backdrop-blur-md border border-white/10 rounded-xl shadow-[inset_0_1px_1px_rgba(255,255,255,0.2),0_4px_8px_rgba(0,0,0,0.3)] transition-all duration-300 ease-out transform ${
                        method === 'card' ? 'translate-x-full' : 'translate-x-0'
                      }`} 
                    />
                    <button
                      type="button"
                      onClick={() => setMethod('crypto')}
                      className={`relative z-10 flex-1 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer ${
                        method === 'crypto' ? 'text-white' : 'text-slate-500 hover:text-slate-300'
                      }`}
                    >
                      🌐 Криптовалюта
                    </button>
                    <button
                      type="button"
                      onClick={() => setMethod('card')}
                      className={`relative z-10 flex-1 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer ${
                        method === 'card' ? 'text-white' : 'text-slate-500 hover:text-slate-300'
                      }`}
                    >
                      💳 Карта РФ
                    </button>
                  </div>
                </div>

                {/* 2. Сумма вывода */}
                <div>
                  <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                    Сумма вывода (USDT)
                  </label>
                  <input 
                    type="number" 
                    step="0.01"
                    min="5"
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Мин. 5.00" 
                    className="w-full px-4 py-3 bg-slate-900/50 backdrop-blur-sm border border-white/10 rounded-xl text-slate-200 placeholder-slate-500 focus:outline-none focus:border-indigo-500 transition-colors shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]"
                  />
                  <p className="text-[11px] text-slate-500 mt-1">Минимальная сумма вывода — 5.00 USDT</p>
                </div>

                {/* 3. Динамические поля: Выбор сети (крипта) или Номер карты (карта) */}
                {method === 'crypto' ? (
                  <>
                    <div>
                      <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                        Сеть (Blockchain)
                      </label>
                      <select 
                        value={network}
                        onChange={(e) => setNetwork(e.target.value)}
                        className="w-full px-4 py-3 bg-slate-900/50 backdrop-blur-sm border border-white/10 rounded-xl text-slate-200 focus:outline-none focus:border-indigo-500 transition-colors cursor-pointer shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)] [&>option]:bg-slate-900"
                      >
                        <option value="TRC20">TRON (TRC-20)</option>
                        <option value="TON">TON Network (TON)</option>
                        <option value="BEP20">BNB Smart Chain (BEP-20)</option>
                        <option value="ERC20">Ethereum (ERC-20)</option>
                        <option value="POLYGON">Polygon (POL)</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                        Адрес кошелька
                      </label>
                      <input 
                        type="text" 
                        required={method === 'crypto'}
                        value={wallet}
                        onChange={(e) => setWallet(e.target.value)}
                        placeholder="Введите адрес кошелька..." 
                        className="w-full px-4 py-3 bg-slate-900/50 backdrop-blur-sm border border-white/10 rounded-xl text-slate-200 placeholder-slate-500 focus:outline-none focus:border-indigo-500 transition-colors shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]"
                      />
                    </div>
                  </>
                ) : (
                  <div>
                    <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                      Номер банковской карты (РФ)
                    </label>
                    <input 
                      type="text" 
                      required={method === 'card'}
                      value={cardNumber}
                      onChange={(e) => setCardNumber(e.target.value)}
                      placeholder="2200 0000 0000 0000" 
                      maxLength={22}
                      className="w-full px-4 py-3 bg-slate-900/50 backdrop-blur-sm border border-white/10 rounded-xl text-slate-200 placeholder-slate-500 focus:outline-none focus:border-indigo-500 transition-colors tracking-wide shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]"
                    />
                    <p className="text-[11px] text-slate-500 mt-1">Поддерживаются карты МИР, Visa, Mastercard РФ</p>
                  </div>
                )}

                {/* 4. Комментарий / Memo */}
                <div>
                  <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                    Комментарий / Memo (опционально)
                  </label>
                  <input 
                    type="text" 
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Memo, Tag или примечание..." 
                    className="w-full px-4 py-3 bg-slate-900/50 backdrop-blur-sm border border-white/10 rounded-xl text-slate-200 placeholder-slate-500 focus:outline-none focus:border-indigo-500 transition-colors shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]"
                  />
                </div>

                {/* Блок предупреждения о комиссии */}
                {method === 'card' ? (
                  <div className="p-3 bg-amber-500/10 border border-amber-500/20 backdrop-blur-sm rounded-xl text-xs text-amber-200 leading-relaxed shadow-inner">
                    ⚠️ <b>Обратите внимание:</b> Комиссия шлюза при выводе на банковскую карту выше, чем при прямом выводе через сети TON и пр.
                  </div>
                ) : (
                  <div className="p-3 bg-amber-500/10 border border-amber-500/20 backdrop-blur-sm rounded-xl text-xs text-amber-200 leading-relaxed shadow-inner">
                    ⚠️ <b>Внимание:</b> Комиссию сети за перевод оплачивает получатель (вычитается из итоговой суммы перевода).
                  </div>
                )}

                <button 
                  type="submit"
                  disabled={loading}
                  className="w-full mt-2 bg-indigo-600/80 hover:bg-indigo-500/90 disabled:bg-slate-700 disabled:text-slate-400 backdrop-blur-md border border-indigo-400/30 text-white font-medium py-3.5 rounded-xl shadow-[inset_0_1px_1px_rgba(255,255,255,0.3),0_8px_20px_rgba(0,0,0,0.4)] transition-all active:scale-[0.98] cursor-pointer"
                >
                  {loading ? 'Создание заявки...' : 'Запросить вывод'}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    );
}

export default UserMenu;